import React from "react";
import Account from "./pages/Account";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AuthProvider } from "./hooks/useAuth";
import Layout from "./components/layout/Layout";
import Dashboard from "./pages/Dashboard";
import AirQuality from "./pages/AirQuality";
import Weather from "./pages/Weather";
import GISMap from "./pages/GISMap";
import Satellites from "./pages/Satellites";
import Alerts from "./pages/Alerts";
import Reports from "./pages/Reports";
import AIIntelligence from "./pages/AIIntelligence";
import Pricing from "./pages/Pricing";
import { Login, Register } from "./pages/Auth";
import "./styles/global.css";

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 5 * 60 * 1000, retry: 2 } }
});

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* Auth pages — no layout */}
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/pricing" element={<Pricing />} />

            {/* Main dashboard — with sidebar layout */}
            <Route path="/*" element={
              <Layout>
                <Routes>
                  <Route path="/"            element={<Dashboard />} />
                  <Route path="/air-quality" element={<AirQuality />} />
                  <Route path="/weather"     element={<Weather />} />
                  <Route path="/map"         element={<GISMap />} />
                  <Route path="/alerts"      element={<Alerts />} />
                  <Route path="/satellites" element={<Satellites />} />
                  <Route path="/reports"     element={<Reports />} />
                  <Route path="/ai"          element={<AIIntelligence />} />
                  <Route path="/account" element={<Account />} />
                </Routes>
              </Layout>
            } />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </QueryClientProvider>
  );
}
